import { StatusTypes } from '@components/common/StatusBadge/StatusBadge.component'
import { AppointmentStatus } from '@dataTypes/appointment.type'

export const AppointmentStatusMap: Record<AppointmentStatus, StatusTypes> = {
  [AppointmentStatus.Confirmed]: StatusTypes.Confirmed,
  [AppointmentStatus.Completed]: StatusTypes.Completed,
  [AppointmentStatus.Pending]: StatusTypes.Pending,
  [AppointmentStatus.Alert]: StatusTypes.Alert,
  [AppointmentStatus.FollowUp]: StatusTypes.FollowUp,
  [AppointmentStatus.NewPatient]: StatusTypes.NewPatient,
  [AppointmentStatus.Cancelled]: StatusTypes.Cancelled,
  [AppointmentStatus.NoShow]: StatusTypes.NoShow,
  [AppointmentStatus.Late]: StatusTypes.Late,
  [AppointmentStatus.Unconfirmed]: StatusTypes.Unconfirmed,
  [AppointmentStatus.CheckIn]: StatusTypes.CheckIn,
  [AppointmentStatus.InTreatment]: StatusTypes.InTreatment,
  [AppointmentStatus.CheckOut]: StatusTypes.CheckOut,
}
